import { render, staticRenderFns } from "./contactRow.vue?vue&type=template&id=c1472a62&scoped=true&"
import script from "./contactRow.vue?vue&type=script&lang=js&"
export * from "./contactRow.vue?vue&type=script&lang=js&"
import style0 from "./contactRow.vue?vue&type=style&index=0&id=c1472a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1472a62",
  null
  
)

export default component.exports